module.exports = __webpack_public_path__ + "static/img/1-2.61ae199.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/1-2.png
// module id = EyEK
// module chunks = 0